import React from "react";

const RadialProgress = ({ size, strokeWidth, percentage }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <svg
      width={size}
      height={size}
      className={`si-radial-progress-svg si-size-${size}`}
    >
      {/* Background Track */}
      <circle
        className="si-track"
        strokeWidth={strokeWidth}
        r={radius}
        cx={size / 2}
        cy={size / 2}
      />
      {/* Progress Bar */}
      <circle
        className="si-progress-bar"
        strokeWidth={strokeWidth}
        strokeDasharray={`${circumference} ${circumference}`}
        style={{ strokeDashoffset: offset }}
        r={radius}
        cx={size / 2}
        cy={size / 2}
      />
    </svg>
  );
};

export default RadialProgress;
